/**
 * Given a fetch-like function, return a new one which parses the response body as JSON.
 */
export function jsonBody<T>(f: typeof fetch): (...args: Parameters<typeof fetch>) => Promise<T> {
  return async (input: RequestInfo | URL, init?: RequestInit): Promise<T> => {
    const response = await f(input, init);
    return response.json();
  };
}
